var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "specifications-and-inventory" },
    [
      _c(
        "el-form",
        _vm._b(
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.cloneForm.productType == 3,
                expression: "cloneForm.productType==3",
              },
            ],
            ref: "couponFormRef",
            attrs: { model: _vm.couponSkuInfo, rules: _vm.couponRules },
          },
          "el-form",
          _vm.formConfig,
          false
        ),
        [
          _c(
            "el-form-item",
            { attrs: { label: "优惠券名称：", prop: "couponId" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    clearable: "",
                    placeholder: "请选择",
                    filterable: "",
                    "filter-method": _vm.handleCouponSearch,
                  },
                  on: { change: _vm.changeCoupon },
                  model: {
                    value: _vm.couponSkuInfo.couponId,
                    callback: function ($$v) {
                      _vm.$set(_vm.couponSkuInfo, "couponId", $$v)
                    },
                    expression: "couponSkuInfo.couponId",
                  },
                },
                _vm._l(_vm.couponList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "规格名称：", prop: "suk" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入" },
                model: {
                  value: _vm.couponSkuInfo.suk,
                  callback: function ($$v) {
                    _vm.$set(_vm.couponSkuInfo, "suk", $$v)
                  },
                  expression: "couponSkuInfo.suk",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "sku名称：", prop: "skuName" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入" },
                model: {
                  value: _vm.couponSkuInfo.skuName,
                  callback: function ($$v) {
                    _vm.$set(_vm.couponSkuInfo, "skuName", $$v)
                  },
                  expression: "couponSkuInfo.skuName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "sku编码：", prop: "skuCode" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入" },
                model: {
                  value: _vm.couponSkuInfo.skuCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.couponSkuInfo, "skuCode", $$v)
                  },
                  expression: "couponSkuInfo.skuCode",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "规格图片：", prop: "attrImage" } },
            [
              _vm.userType === 1
                ? _c("div", [
                    _vm.couponSkuInfo.attrImage
                      ? _c("img", {
                          staticClass: "attr-img",
                          attrs: { src: _vm.couponSkuInfo.attrImage },
                          on: { click: _vm.attrImage },
                        })
                      : _c("i", {
                          staticClass: "el-icon-camera cameraIconfont pointer",
                          on: { click: _vm.attrImage },
                        }),
                  ])
                : _c(
                    "div",
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            "show-file-list": false,
                            "before-upload": _vm.beforeAttrImageUpload,
                            "http-request": _vm.handleAttrImageUpload,
                            accept: "image/*",
                          },
                        },
                        [
                          _vm.couponSkuInfo.attrImage
                            ? _c("img", {
                                staticClass: "attr-img",
                                attrs: { src: _vm.couponSkuInfo.attrImage },
                              })
                            : _c("i", {
                                staticClass:
                                  "el-icon-camera cameraIconfont pointer",
                              }),
                        ]
                      ),
                    ],
                    1
                  ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "主图管理：", prop: "image" } },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", "align-items": "center" } },
                [
                  _vm._l(_vm.couponSkuInfo.image, function (img, i) {
                    return _c("el-image", {
                      key: i,
                      staticStyle: {
                        width: "50px",
                        height: "50px",
                        "margin-right": "20px",
                      },
                      attrs: {
                        src: img,
                        "preview-src-list": _vm.couponSkuInfo.image,
                      },
                    })
                  }),
                  _vm._v(" "),
                  _vm.userType === 1
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "mini" },
                          on: { click: _vm.handleMainImage },
                        },
                        [_vm._v("主图管理")]
                      )
                    : _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader-main",
                          attrs: {
                            "show-file-list": false,
                            "before-upload": _vm.beforeMainImageUpload,
                            "http-request": _vm.handleMainImageLocalUpload,
                            accept: "image/*",
                            multiple: "",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { type: "primary", size: "mini" } },
                            [_vm._v("上传主图")]
                          ),
                        ],
                        1
                      ),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { width: "100%" }, attrs: { gutter: 24 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "原价：", prop: "otPrice" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: { min: 0, clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.couponSkuInfo.otPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.couponSkuInfo, "otPrice", $$v)
                          },
                          expression: "couponSkuInfo.otPrice",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "供货价：", prop: "supplyPrice" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: { min: 0, clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.couponSkuInfo.supplyPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.couponSkuInfo, "supplyPrice", $$v)
                          },
                          expression: "couponSkuInfo.supplyPrice",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "指导价：", prop: "guidePrice" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: { min: 0, clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.couponSkuInfo.guidePrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.couponSkuInfo, "guidePrice", $$v)
                          },
                          expression: "couponSkuInfo.guidePrice",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "默认售价：", prop: "defaultPrice" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: { min: 0, clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.couponSkuInfo.defaultPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.couponSkuInfo, "defaultPrice", $$v)
                          },
                          expression: "couponSkuInfo.defaultPrice",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "库存数量：", prop: "stock" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          min: 0,
                          disabled: _vm.isCouponStockLocked,
                          clearable: "",
                          placeholder: "请输入",
                        },
                        model: {
                          value: _vm.couponSkuInfo.stock,
                          callback: function ($$v) {
                            _vm.$set(_vm.couponSkuInfo, "stock", $$v)
                          },
                          expression: "couponSkuInfo.stock",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "库存预警：", prop: "stockWarning" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: { min: 0, clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.couponSkuInfo.stockWarning,
                          callback: function ($$v) {
                            _vm.$set(_vm.couponSkuInfo, "stockWarning", $$v)
                          },
                          expression: "couponSkuInfo.stockWarning",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "采销状态：", prop: "cpStatus" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            clearable: "",
                            size: "mini",
                            placeholder: "请选择",
                          },
                          model: {
                            value: _vm.couponSkuInfo.cpStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.couponSkuInfo, "cpStatus", $$v)
                            },
                            expression: "couponSkuInfo.cpStatus",
                          },
                        },
                        _vm._l(_vm.cpStatusEnum, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "上下架状态：", prop: "listStatus" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            clearable: "",
                            size: "mini",
                            placeholder: "请选择",
                          },
                          model: {
                            value: _vm.couponSkuInfo.listStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.couponSkuInfo, "listStatus", $$v)
                            },
                            expression: "couponSkuInfo.listStatus",
                          },
                        },
                        _vm._l(_vm.goodsStatusEnum, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "条形码", prop: "barCode" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.couponSkuInfo.barCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.couponSkuInfo, "barCode", $$v)
                          },
                          expression: "couponSkuInfo.barCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        _vm._b(
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.cloneForm.productType != 3,
                expression: "cloneForm.productType!=3",
              },
            ],
            ref: "normalFormRef",
            attrs: { model: _vm.form, rules: _vm.rules },
          },
          "el-form",
          _vm.formConfig,
          false
        ),
        [
          _c(
            "el-form-item",
            { attrs: { label: "选择规格：", prop: "selectRule" } },
            [
              _c(
                "div",
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        "value-key": "id",
                        placeholder: "请选择",
                        clearable: "",
                        disabled: _vm.ID ? true : false,
                      },
                      on: { clear: _vm.clear },
                      model: {
                        value: _vm.form.selectRule,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "selectRule", $$v)
                        },
                        expression: "form.selectRule",
                      },
                    },
                    _vm._l(_vm.comData.ruleList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.ruleName, value: item },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: !_vm.form.selectRule,
                        type: "primary",
                        plain: !_vm.form.selectRule,
                      },
                      on: { click: _vm.confirm },
                    },
                    [_vm._v("确认")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        plain: "",
                        disabled: _vm.ID ? true : false,
                      },
                      on: { click: _vm.addRule },
                    },
                    [_vm._v("添加规格")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.cloneForm.productType == 4
                ? _c("div", { staticStyle: { color: "red" } }, [
                    _vm._v(
                      "家政商品，请在规格中注明服务时间。时间需用数字表示，例如：1小时、2小时！"
                    ),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.selectRuleList.length,
                  expression: "selectRuleList.length",
                },
              ],
              staticClass: "rule-box",
            },
            _vm._l(_vm.selectRuleList, function (tag, index) {
              return _c("div", { key: index, staticClass: "rule-item" }, [
                _c(
                  "div",
                  { staticClass: "tag-item-name" },
                  [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          closable: "",
                          type: "success",
                          effect: "plain",
                        },
                        on: {
                          close: function ($event) {
                            return _vm.handleTagNameClose(index)
                          },
                        },
                      },
                      [_vm._v(_vm._s(tag.value))]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tag-item-detail" },
                  [
                    _vm._l(tag.detail, function (tagItem) {
                      return _c(
                        "el-tag",
                        {
                          key: tagItem,
                          attrs: { closable: "" },
                          on: {
                            close: function ($event) {
                              return _vm.handleTagClose(index, tagItem)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " + _vm._s(tagItem) + "\n          "
                          ),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    tag.inputVisible
                      ? _c("el-input", {
                          ref: "saveTagInput",
                          refInFor: true,
                          staticClass: "input-new-tag",
                          attrs: { size: "mini" },
                          on: {
                            blur: function ($event) {
                              return _vm.handleInputConfirm(tag)
                            },
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleInputConfirm(tag)
                            },
                          },
                          model: {
                            value: tag.inputValue,
                            callback: function ($$v) {
                              _vm.$set(tag, "inputValue", $$v)
                            },
                            expression: "tag.inputValue",
                          },
                        })
                      : _c(
                          "el-button",
                          {
                            staticClass: "button-new-tag",
                            attrs: { size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.showInput(index)
                              },
                            },
                          },
                          [_vm._v("+ 添加")]
                        ),
                  ],
                  2
                ),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.selectRuleList.length,
                  expression: "selectRuleList.length",
                },
              ],
            },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isAddRule,
                      expression: "!isAddRule",
                    },
                  ],
                  on: {
                    click: function ($event) {
                      _vm.isAddRule = true
                    },
                  },
                },
                [_vm._v("添加新规格")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isAddRule,
                  expression: "isAddRule",
                },
              ],
              staticClass: "add-rule",
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "规格" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入规格" },
                    model: {
                      value: _vm.addRuleForm.attrName,
                      callback: function ($$v) {
                        _vm.$set(_vm.addRuleForm, "attrName", $$v)
                      },
                      expression: "addRuleForm.attrName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "规格值" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入规格值" },
                    model: {
                      value: _vm.addRuleForm.attrValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.addRuleForm, "attrValue", $$v)
                      },
                      expression: "addRuleForm.attrValue",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addRuleItem },
                    },
                    [_vm._v("确定")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.isAddRule = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.attrValue && _vm.form.attrValue.length,
                  expression: "form.attrValue && form.attrValue.length",
                },
              ],
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "批量设置：" } },
                [
                  _c("BatchSetVue", {
                    attrs: {
                      "product-type": _vm.cloneForm.productType,
                      "is-edit": !!_vm.ID,
                    },
                    on: { updataAttrValue: _vm.updataAttrValue },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商品属性：", prop: "attrValue" } },
                [
                  _c("GoodsAttrbuit", {
                    ref: "GoodsAttrbuitRef",
                    attrs: {
                      list: _vm.form.attrValue,
                      "product-type": _vm.cloneForm.productType,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("MainImageVue", {
        ref: "mainImageRef",
        on: { mainImageList: _vm.mainImageList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }